/* eslint-disable */
export enum SideBarRoutes {
  DASHBOARD = '/dashboard',
  MY_QRS = '/my-qrs',
  MY_LINK = '/my-link',
  MY_URLS = '/my-urls',
  ANALYTICS = '/analytics',
}
